var map = {
  "./cs.json": [
    "CFQ",
    [
      "06"
    ]
  ],
  "./en.json": [
    "YVR",
    [
      "uml"
    ]
  ],
  "./pl.json": [
    "zm",
    [
      "dj1"
    ]
  ],
  "./ru.json": [
    "MnK",
    [
      "un"
    ]
  ],
  "./tr.json": [
    "KBO",
    [
      "s9"
    ]
  ],
  "./ja.json": [
    "x6L",
    [
      "3p6"
    ]
  ],
  "./zh.json": [
    "buc",
    [
      "d"
    ]
  ],
  "./pt-br.json": [
    "csM",
    [
      "2y"
    ]
  ],
  "./de.json": [
    "cxo",
    [
      "ad"
    ]
  ],
  "./es.json": [
    "x6M",
    [
      "jn"
    ]
  ],
  "./fr.json": [
    "Vp",
    [
      "n3d"
    ]
  ],
  "./it.json": [
    "K8u",
    [
      "g9"
    ]
  ],
  "./ko.json": [
    "Cj",
    [
      "oq"
    ]
  ],
  "./pt.json": [
    "Ila",
    [
      "a1"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "T5";
module.exports = __rspack_async_context;
